import { render, staticRenderFns } from "./InsuranceBridgeNavigation.vue?vue&type=template&id=40afc048&scoped=true&"
import script from "./InsuranceBridgeNavigation.vue?vue&type=script&lang=js&"
export * from "./InsuranceBridgeNavigation.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceBridgeNavigation.vue?vue&type=style&index=0&id=40afc048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40afc048",
  null
  
)

export default component.exports